import { useHistory } from 'react-router';
import { useCallback } from 'react';

import { UserRole } from '@project/types/role/role.types';

const roleRedirectMap: Record<UserRole, string> = {
  PortalUser: '/',
  SuperAdministrator: '/admin',
  Consultant: '/admin',
  CallCenterAgent: '/admin',
  CallCenterManager: '/admin',
  Finance: '/admin',
};

export const useRoleRedirect = () => {
  const history = useHistory();

  const redirect = useCallback(
    (role: string) => {
      const destination = roleRedirectMap[role as UserRole] ?? '/login';
      history.replace(destination);
    },
    [history],
  );

  return redirect;
};
